import get from 'lodash/get';
import { redirectToLogin } from '../../../../utils/redirectMethods';
import env from '../../utils/env';

function handleUnauthorizedReq() {
  redirectToLogin();
  // Returning a promise that never resolves so that we can await this function call,
  // which allows us to ensure that no code is executed after this function returns.
  // In doing so, we eliminate a possible race condition where a later line of code
  // could send the user to a page other than the login page, like the oops page.
  return new Promise(() => null);
}

async function requestJson(
  path: string,
  method: string,
  headers: Record<string, string>,
  body?: BodyInit | undefined | null,
) {
  const defaultHeaders = {
    'FFF-Auth': 'V1.1',
    Accept: 'application/vnd.fabfitfun.v2+json',
    Origin: env.hostname,
  };

  const response = await fetch(path, {
    credentials: 'include',
    headers: { ...defaultHeaders, ...headers },
    data: {
      activatedOn: true,
    },
    body,
    mode: 'cors',
    method,
  });

  if (path.match(/ace-api/) && response.status === 401) {
    await handleUnauthorizedReq();
  }

  const parsedResponse = await response.json();
  if (!response.ok || get(parsedResponse, 'error')) throw parsedResponse;
  return parsedResponse;
}

export default requestJson;
